import { useSearchTypeFromRoute } from '@aibees/elephant/hooks';
import { SearchType } from '@aibees/elephant/types';

export function useGetAvatarBasedOnSearchType() {
  const type = useSearchTypeFromRoute();

  let srcList: string[] = [];

  if (type === SearchType.Company)
    srcList = [
      '/assets/avatar/company1.png',
      '/assets/avatar/company2.png',
      '/assets/avatar/company3.png',
      '/assets/avatar/company4.png',
      '/assets/avatar/company5.png',
    ];

  if (type === SearchType.People)
    srcList = [
      '/assets/avatar/people1.jpg',
      '/assets/avatar/people2.jpg',
      '/assets/avatar/people3.jpg',
      '/assets/avatar/people4.jpg',
      '/assets/avatar/people5.jpg',
    ];
  return srcList;
}
